export default __webpack_public_path__ + "static/media/avatar.72ef8f65.png";